import ForAdults from 'components/forAdults/ForAdults';
import React from 'react';

const Adults = () => {
  return (
    <section>
      <ForAdults />
    </section>
  );
};

export default Adults;
